import type { ReactNode, FC, SyntheticEvent } from 'react';
import Link from 'next/link';

interface NextLinkProps {
  children: ReactNode;
  href?: string;
  target?: '_blank' | '_self' | '_parent' | '_top';
  className?: string;
  key?: string;
  onClick?: (event: SyntheticEvent) => void;
  onKeyUp?: (event: SyntheticEvent) => void;
  onKeyDown?: (event: SyntheticEvent) => void;
  onMouseEnter?: (event: SyntheticEvent) => void;
  onMouseLeave?: (event: SyntheticEvent) => void;
  onMouseOver?: (event: SyntheticEvent) => void;
  onBlur?: (event: SyntheticEvent) => void;
  tabIndex?: number;
  rel?: string;
  id?: string;
  openInNewTab?: boolean;
}

export const NextLink: FC<NextLinkProps> = ({ href, children, target, openInNewTab, ...rest }) => {
  const finalTarget = target ?? (openInNewTab ? '_blank' : '_self');

  if (finalTarget === '_blank') {
    return (
      <a href={href ?? ''} {...rest} target={finalTarget}>
        {children}
      </a>
    );
  }

  return (
    <Link href={href ?? ''} {...(rest as Partial<NextLinkProps>)} prefetch={false}>
      {children}
    </Link>
  );
};
